/**
 * Privacy / Cookie Policy Version
 *
 * Bump this when the privacy policy or cookie categories change.
 * When bumped, users will be prompted to review consent again.
 */

export const PRIVACY_POLICY_VERSION = '1.0.0'

